const i18nConfig = {
  // This is the list of languages your application supports
  supportedLngs: ['en', 'de', 'ar', 'it', 'zh', 'vi', 'es', 'ms', 'pt', 'tr', 'ja'],
  // This is the language you want to use in case
  // if the user language is not in the supportedLngs
  fallbackLng: 'en',
  // The default namespace of i18next is "translation", but you can customize it here
  //defaultNS: [],
  // Disabling suspense is recommended
  react: { useSuspense: false },
  debug: false,
  returnNull: true, // this needs to be TRUE else if its false weird things happen
}

export default i18nConfig
